import(/* webpackMode: "eager" */ "/vercel/path0/web/web/src/app/pricing/page.tsx");
